import { CoreMenuModel } from '../core';

export class MenuModel extends CoreMenuModel {
	defaults() {
		return {
			menu_for_authorized_users: {
				tops: {
					path:             '/my-tips',
					name:             'My Tips',
					sub_menus_list:   [
						{
							method_name: 'tipping',
							path:        '/my-tips',
							name:        'My Tips'
						},
						{
							method_name: 'myComps',
							path:        '/comps/my-comps',
							name:        'Comps',
							class:       'hidden-desktop'
						},
						{
							method_name: 'streak',
							path:        '/streak',
							name:        'Streak',
							class:       'hidden-desktop'
						},
						{
							method_name: 'rankingsTipping',
							path:        '/rankings/tipping',
							name:        'Rankings',
							class:       'hidden-desktop'
						},
					],
					extra_menus_list: [],
					breadcrumb:       {}
				},
				rankings: {
					path:             '/rankings/tipping',
					name:             'Rankings',
					sub_menus_list:   [
						{
							method_name: 'rankingsTipping',
							path:        '/rankings/tipping',
							name:        'Tipping'
						},
						{
							method_name: 'rankingsComp',
							path:        '/rankings/comp',
							name:        'Comp'
						},
						{
							method_name: 'rankingsStreak',
							path:        '/rankings/streak',
							name:        'Streak'
						}
					],
					extra_menus_list: [],
					top_breadcrumb:       {
						path: '/rankings/tipping',
						name: 'Rankings'
					},
					breadcrumb:       {
						path: '/rankings/tipping',
						name: 'Rankings'
					}
				},
				comps: {
					path:             '/comps/my-comps',
					name:             'Comps',
					sub_menus_list:   [
						{
							method_name: 'tipping',
							path:        '/my-tips',
							name:        'My Tips',
							class:       'hidden-desktop'
						},
						{
							method_name: 'myComps',
							path:        '/comps/my-comps',
							name:        'Comps',
						},
						{
							method_name: 'streak',
							path:        '/streak',
							name:        'Streak',
							class:       'hidden-desktop'
						},
						{
							method_name: 'rankingsTipping',
							path:        '/rankings/tipping',
							name:        'Rankings',
							class:       'hidden-desktop'
						},
						{
							method_name: 'joinComps',
							path:        '/comps/join',
							name:        'Join a Comp',
							class:       'hidden-mobile',
							check_for_end_season: true,
							message: 'Leagues cannot be joined after Round 27 has begun'
						},
						{
							method_name: 'compsCreate',
							path:        '/comps/create',
							name:        'Create a Comp',
							class:       'hidden-mobile',
							check_for_end_season: true,
							message: 'Leagues cannot be created after Round 27 has begun'
						},
					],
					extra_menus_list: [
						{
							method_name: 'compLadder',
							path:        '/comps/:id/ladder',
							name:        'Ladder'
						},
						{
							method_name: 'compSettings',
							path:        '/comps/:id/manage',
							name:        'Settings'
						},
						{
							method_name:             'compInvites',
							path:                    '/comps/:id/manage/invites',
							name:                    'Invites',
							check_by_commissioner:   true,
							check_by_supported_team: true
						}
					],
					breadcrumb:       {
						path: '/comps/my-comps',
						name: 'Comps'
					}
				},
				streak: {
					path:             '/streak',
					name:             'Streak',
					sub_menus_list:   [
						{
							method_name: 'tipping',
							path:        '/my-tips',
							name:        'My Tips',
							class:       'hidden-desktop'
						},
						{
							method_name: 'myComps',
							path:        '/comps/my-comps',
							name:        'Comps',
							class:       'hidden-desktop'
						},
						{
							method_name: 'streak',
							path:        '/streak',
							name:        'Streak'
						},
						{
							method_name: 'rankingsTipping',
							path:        '/rankings/tipping',
							name:        'Rankings',
							class:       'hidden-desktop'
						},
					],
					extra_menus_list: [],
					breadcrumb:       {}
				},
				helps: {
					path:           '/help/faq',
					name:           'Help',
					sub_menus_list: [
						// {
						// 	method_name: 'whatsNew',
						// 	path:        '/help/whats-new',
						// 	name:        'What\'s New'
						// },
						{
							method_name: 'gameGuidelines',
							path:        '/help/guidelines',
							name:        'Game Guidelines'
						},
						{
							method_name: 'faq',
							path:        '/help/faq',
							name:        'FAQs'
						},
						{
							method_name: 'contactUs',
							path:        '/help/contact-us',
							name:        'Contact Us'
						},
						{
							method_name: 'prizes',
							path:        '/help/prizes',
							name:        'Prizes'
						},
						{
							method_name: 'termsAndConditions',
							path:        '/help/terms-and-conditions',
							name:        'Terms and Conditions'
						}
					]
				},
				account:      {
					path:           '/account/settings',
					name:           'My Account',
					sub_menus_list: [
						{
							method_name: 'settings',
							path:        '/account/settings',
							name:        'Acc Settings'
						},
						{
							method_name: 'communications',
							path:        '/account/communications',
							name:        'Communications'
						}
					]
				}
			},
			menu_for_not_authorized_users: {
				home:  {
					path:           '/',
					name:           'Home',
					sub_menus_list: []
				},
				helps: {
					path:           '/help/faq',
					name:           'Help',
					sub_menus_list: [
						// {
						// 	method_name: 'whatsNew',
						// 	path:        '/help/whats-new',
						// 	name:        'Whats New'
						// },
						{
							method_name: 'gameGuidelines',
							path:        '/help/guidelines',
							name:        'Game Guidelines'
						},
						{
							method_name: 'faq',
							path:        '/help/faq',
							name:        'FAQs'
						},
						{
							method_name: 'contactUs',
							path:        '/help/contact-us',
							name:        'Contact Us'
						},
						{
							method_name: 'prizes',
							path:        '/help/prizes',
							name:        'Prizes'
						},
						{
							method_name: 'termsAndConditions',
							path:        '/help/terms-and-conditions',
							name:        'Terms and Conditions'
						}
					]
				}
			},
			external_menu_items:       [
				{
					path: process.env.FANTASY_LINK,
					name: 'Fantasy'
				},
				{
					path: process.env.NRL_URL + '/news/topic/fantasy/',
					name: 'Fantasy News'
				},
				{
					path: process.env.FANTASY_LINK + '/draft',
					name: 'Draft'
				},
				{
					path: process.env.NRL_URL,
					name: 'NRL Home'
				},
				{
					path: 'http://ladderpredictor.nrl.com?source=tipping',
					name: 'Ladder Predictor'
				},
			],
			id:                            0,
			show_extra_menu:               false,
			is_authorized:                 true,
			menu_items:                    {},
			current_menu:                  {}
		};
	}
}

export default MenuModel;